// src/directives/vTooltip.js
import { Tooltip } from 'bootstrap';

const tooltipDirective = {
  // Chamado antes que os atributos do elemento ou ouvintes de eventos sejam aplicados.
  created(el, binding) {
    // Armazena as opções iniciais no elemento, se houver
    el._tooltipOptions = {
      title: binding.value || el.getAttribute('data-bs-title'),
      placement: el.getAttribute('data-bs-placement') || 'top',
      // Adicione outras opções padrão ou customizáveis aqui
    };
  },

  // Chamado após o componente ser montado na DOM (ou quando o elemento é inserido na DOM).
  mounted(el) {
    // Garante que não há tooltips duplicados.
    // Se já existe um tooltip no elemento, destrua-o antes de criar um novo.
    if (el._bsTooltip) {
      el._bsTooltip.dispose();
      el._bsTooltip = null;
    }

    // Inicializa o tooltip do Bootstrap no elemento.
    // Passa as opções salvas em created.
    el._bsTooltip = new Tooltip(el, el._tooltipOptions);
  },

  // Chamado antes que o próprio componente do vnode pai seja atualizado.
  // Pode ser usado para atualizar o tooltip se o valor do binding mudar.
  updated(el, binding) {
    // Se o texto do tooltip ou outras opções mudarem, atualiza o tooltip
    const newTitle = binding.value || el.getAttribute('data-bs-title');
    if (el._bsTooltip && el._tooltipOptions.title !== newTitle) {
      el._bsTooltip.dispose(); // Destrói o antigo
      el._tooltipOptions.title = newTitle; // Atualiza o título
      el._bsTooltip = new Tooltip(el, el._tooltipOptions); // Cria um novo com o título atualizado
    }
  },

  // Chamado quando o componente é desmontado (ou quando o elemento é removido da DOM).
  unmounted(el) {
    // Garante que o tooltip seja destruído para evitar vazamento de memória e erros.
    if (el._bsTooltip) {
      el._bsTooltip.dispose(); // Destrói a instância do tooltip
      el._bsTooltip = null;    // Limpa a referência
    }
  },
};

export default tooltipDirective;